module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zLLtqz/tc-custom/9780813139418.jpg?1726943689248",
      "alt": "This image is the cover for the book Striking Back, Combat in Korea"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Striking Back, Combat in Korea\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The editor of "), _c('i', [_vm._v("The Line")]), _vm._v(" “gives a human perspective to the war” by focusing on fighting by battalion, company, platoon, squad, and individual soldiers ("), _c('i', [_vm._v("The Journal of America’s Military Past")]), _vm._v(").")]), _c('br'), _c('br'), _c('i', [_vm._v("Striking Back: Combat in Korea, March–April 1951")]), _vm._v(" is the second book in a three-volume series about the Korean War, examining the fighting that occurred during the late winter and early spring of the war’s first year. By the beginning of March, UN forces shifted strategic focus from defense to offense. In April, the combination of stabilized fronts and the enemy’s failed attacks made conditions ideal for launching combat offensives. The brutal nature and strategic significance of these campaigns is described in the book, which includes analysis of their profound influence on the remainder of the war. William T. Bowers provides detailed battle narratives based on eyewitness accounts recorded by Army historians within days of the operations. Through his use of personal accounts, official records, war diaries, and combat reports, Bowers sheds new light on the conflict in Korea, making this volume a must-read for military historians."), _c('br'), _c('br'), _c('b', [_vm._v("“This book is unique.” —"), _c('i', [_vm._v("In Review")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William T. Bowers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("William T. Bowers (1946–2008), a former U.S. Army officer, is coauthor of Black Soldier, White Army.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University Press of Kentucky\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0